import {gql} from "@apollo/client";

export const GET_ZIPCODE_LISTING = gql`
    query ZipcodeQuery($filters: ZipcodeFiltersTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getZipcodeListing(filters: $filters,
                          pageRequest: $pageRequest) {
            content{
                zipcode
                city
                state
                county
                timezone
                latitude
                longitude
                sortingCode
                isDelivery
                isPickup
                isTakingDeliveryOrder
                allowTakingOrder
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface ZipcodeType {
    zipcode: string;
    city: string;
    state: string;
    county?: string;
    timezone?: string;
    latitude?: number;
    longitude?: number;
    sortingCode?: string;
    isDelivery: boolean;
    isPickup: boolean;
    isTakingDeliveryOrder: boolean;
    allowTakingOrder: boolean;
    updatedAt: string;
}

export interface ZipcodeListingResponseType {
    content: ZipcodeType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface ZipcodeListResponse {
    getZipcodeListing: ZipcodeListingResponseType;
}

export interface ZipcodeFiltersType {
    zipcode?: string;
    city?: string;
    state?: string;
    county?: string;
    timezone?: string;
    sortingCode?: string;
    isDelivery?: boolean;
    isPickup?: boolean;
    isTakingDeliveryOrder?: boolean;
    allowTakingOrder?: boolean;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}

export interface GetZipcodeListingInput {
    filters?: ZipcodeFiltersType;
    pageRequest?: PageRequestType;
} 